import { useTextCms } from '../context/TextCmsContext';

export const useText = (key: string, defaultValue?: string): string => {
  const { getText } = useTextCms();
  return getText(key, defaultValue);
};

export default useText;
